module.exports = __webpack_public_path__ + "media/images/sp/icon-minus-10bb59427f0a2c1159f58d0f54f0a380.png";